import { render, staticRenderFns } from "./ClientSpend.vue?vue&type=template&id=1972c983&scoped=true&"
import script from "./ClientSpend.vue?vue&type=script&lang=js&"
export * from "./ClientSpend.vue?vue&type=script&lang=js&"
import style0 from "./ClientSpend.vue?vue&type=style&index=0&id=1972c983&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972c983",
  null
  
)

export default component.exports